import { createElement } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import DOMPurify from "dompurify";
import { SafeMarkdown } from "@/components/markdown/SafeMarkdown";
import remarkGfm from "remark-gfm";

const PRINT_STYLES = `
  body{font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,Cantarell,'Open Sans','Helvetica Neue',sans-serif;line-height:1.6;color:#111;max-width:800px;margin:0 auto;padding:32px}
  h1,h2,h3,h4{margin-top:1.2em;margin-bottom:.6em}
  ul,ol{padding-left:1.5em}
  table{border-collapse:collapse;width:100%;margin:1em 0}
  th,td{border:1px solid #ddd;padding:8px;text-align:left}
  blockquote{border-left:4px solid #ddd;padding-left:1em;color:#555;margin:0}
  @media print{.no-print{display:none}}
`;

export function staffReportMarkdownToPrintHtml(markdown: string): string {
  return DOMPurify.sanitize(
    renderToStaticMarkup(
      createElement(SafeMarkdown, { remarkPlugins: [remarkGfm] }, markdown),
    ),
  );
}

export function writeStaffReportPrintDocument(
  printWindow: Pick<Window, "document">,
  options: { title: string; bodyHtml: string },
): void {
  const escapedTitle = options.title.replace(/</g, "&lt;").replace(/>/g, "&gt;");
  printWindow.document.open();
  printWindow.document.write(`<!doctype html>
<html>
  <head>
    <meta charset="utf-8" />
    <title>${escapedTitle}</title>
    <style>${PRINT_STYLES}</style>
  </head>
  <body>
    <div id="content"></div>
  </body>
</html>`);
  printWindow.document.close();
  const content = printWindow.document.getElementById("content");
  if (content) content.innerHTML = options.bodyHtml;
}

export function openStaffReportPrintPreview(options: { title: string; markdown: string }): void {
  const printWindow = window.open("", "_blank");
  if (!printWindow) return;
  writeStaffReportPrintDocument(printWindow, {
    title: options.title,
    bodyHtml: staffReportMarkdownToPrintHtml(options.markdown),
  });
  printWindow.print();
}
